import { Utils } from "../utilities/Utils";
import { UserRole } from "./Enums";

export interface IUser {
    id: number;
    guid: string;
    role: UserRole;
    status: number;
    email: string;
    phoneNumber: string;
    forename: string;
    surname: string;
    lastLoggedIn: Date;
    prevLastLoggedIn: Date;
    created: Date;
    createdByUserID: number;
    lastUpdated: Date;
    lastUpdatedByUserID: number;
    deleted: Date;
    deletedByUserID: number;

    password: string;
    repeatPassword: string;
}

export class User implements IUser {

    constructor(data?: IUser) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IUser) {
        Utils.clone(data, this);
    }

    id: number = 0;
    guid: string = Utils.emptyGuidValue;
    role: UserRole = UserRole.None;
    status: number = 0;
    email: string = "";
    phoneNumber: string = "";
    forename: string = "";
    surname: string = "";
    lastLoggedIn: Date = new Date(Utils.emptyDateValue);
    prevLastLoggedIn: Date = new Date(Utils.emptyDateValue);
    created: Date = new Date(Utils.emptyDateValue);
    createdByUserID: number = 0;
    lastUpdated: Date = new Date(Utils.emptyDateValue);
    lastUpdatedByUserID: number = 0;
    deleted: Date = new Date(Utils.emptyDateValue);
    deletedByUserID: number = 0;
    jwtBearerToken: string = "";

    password: string = "";
    repeatPassword: string = "";


    get isNew() {
        return Utils.isEmptyId(this.id);
    }

    get isDeleted() {
        return Utils.hasDateValue(this.deleted);
    }

    get fullname() {
        return this.forename + " " + this.surname;
    }
}